export default __webpack_public_path__ + "static/blog-img7-44c5ecb8506447633d6d20684655fd7d.jpg";